import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { Colors } from "../../../constants/Style";
export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    background: "transparent",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    paddingRight: theme.spacing(4),
    paddingLeft: "24px",
    borderRight: "2px solid #004A96",
    fontSize: theme.spacing(2),
    lineHeight: "32px",
    height: "32px",
    whiteSpace: "nowrap",
    color: Colors.white,
    // LB-451
    // cursor: "pointer",
    "& p": {
      fontWeight: 500,
    },
    [theme.breakpoints.down("sm")]: {
      borderRight: "none",
      justifyContent: "flex-start",
    },
  },
  points: {
    fontWeight: 500,
    color: Colors.white,
    paddingLeft: "4px",
  },
  icon: {
    paddingLeft: theme.spacing(0.5),
    width: 22,
    "& svg": {
      minWidth: 16,
      width: 16,
      minHeight: 16,
      height: 16,
    },
  },
}));
